import axios from 'axios';
import qs from 'query-string';
import { format } from 'date-fns';

import { navigateWithParams } from 'Utils/horseRacingRouteHelper';
import errorMessage from 'Store/actions/errorMessage';
import { catchTJKError } from 'Utils/catchTJKError';
import { GET_HORSE_RACEING_RESULT, GET_HORSE_RACEING_RESULT_SUCCESS, GET_HORSE_RACEING_RESULT_FAILURE, GET_HIPPODROME_HORSE_RACEING_RESULT, GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE, GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS, GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE } from 'Store/constants';
import { horseRacingResultsMapper, horseRacingHippodromeResultsMapper, horseRacingHippodromeRunResultsMapper } from 'Utils/horseRacesNameMapper';
import ProjectConfig from 'ProjectConfig';

export const getRacingResults = raceDate => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACEING_RESULT,
    });
  
    const date = format(new Date(raceDate), 'dd-MM-yyyy');
    
    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/results/program/${date}`;
    const res = await axios.get(apiUrl);


    catchTJKError(res.data);

    const _data = {
      tarih: raceDate,
    };

    navigateWithParams({ type: 'replace', search: qs.stringify(_data) });

    const payload = horseRacingResultsMapper(res.data.body);

    dispatch({
      type: GET_HORSE_RACEING_RESULT_SUCCESS,
      payload: payload
    });
  } catch (e) {
    
    dispatch({
      type: GET_HORSE_RACEING_RESULT_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getHippodromeRacingResults = (programKey, raceDate) => async dispatch => {
  try {
    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RESULT,
    });
  
    const date = format(new Date(raceDate), 'dd-MM-yyyy');

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/results/program/${programKey}/${date}`;
    const res = await axios.get(apiUrl);


    const payload = horseRacingHippodromeResultsMapper(res.data.body);

    catchTJKError(res.data);

    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RESULT_SUCCESS,
      payload: payload
    });
  } catch (e) {
    
    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RESULT_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getHippodromeRacingRunResults = (programKey, raceDate) => async dispatch => {
  try {
    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RUN_RESULT,
    });
  
    const date = format(new Date(raceDate), 'dd-MM-yyyy');

    const apiUrl = ProjectConfig.API_GATEWAY + `/mobile/tjk/results/program/${programKey}/${date}/detail`;
    const res = await axios.get(apiUrl);


    const payload = horseRacingHippodromeRunResultsMapper(res.data.body);

    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_SUCCESS,
      payload: payload
    });
    
  } catch (e) {
    
    dispatch({
      type: GET_HIPPODROME_HORSE_RACEING_RUN_RESULT_FAILURE,
      payload: (e.response && e.response.data) || errorMessage,
    });
  }
};